module.exports = __webpack_public_path__ + "img/famigliaGlaxi.e38d021d.jpg";